/**
 * @description 最底层的基础组件
 * @author duanjun
 */

import { Component } from 'react';

class BaseComponent<T, K> extends Component<T, K> {
    constructor(props: T) {
        super(props);
    }

    public componentWillUnmount() {
        //
    }
    public shouldComponentUpdate(nextProps: T, nextState: K) {
        if (JSON.stringify(this.props) === JSON.stringify(nextProps)
            && JSON.stringify(this.state) === JSON.stringify(nextState)) {
            return false;
        }
        return true;
    }
    public render(): JSX.Element | null {
        return null;
    }
}
export default BaseComponent;
